module.exports = __webpack_public_path__ + "img/api-economy-education.228a2da6.svg";